import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { type JobInfoDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { topConfigContextAtom } from '../atoms/topConfigContextAtom';
import { jobIdAtom } from '../atoms/jobIdAtom';
import { getPrimaryAccountNumber } from '../../utils/topConfigContextUtil';
import type { ProductName_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';

export const jobInfoSelector = selector<JobInfoDTO>({
    key: 'jobInfoSelector',
    get: async ({ get }) => {
        const jobId = get(jobIdAtom);
        const topConfigContext = get(topConfigContextAtom);
        const isLoggedOn = topConfigContext?.user?.isLoggedOn;
        const accountNumber = getPrimaryAccountNumber(topConfigContext);
        // Using URL search parmas instead of opcInfoAtom to avoid side effect when opcInfoAtom is updated
        const urlSearchParams = new URLSearchParams(window.location.search);
        const policeNummer = urlSearchParams.get('policeNummer');
        const coverableId = urlSearchParams.get('coverableId');
        const opcProduct = urlSearchParams.get('productName') as ProductName_Top;

        return await OnlineSalesUnauthenticated.getOrCreateJob(
            isLoggedOn ? accountNumber : '',
            jobId ?? '',
            policeNummer ?? '',
            coverableId ?? '',
            opcProduct,
            !isLoggedOn
        );
    }
});
